<div class="interact-main-container">
  <ngx-loading [show]="loading"></ngx-loading>
  <ng-container *ngFor="let notification of notifications">
    <app-notifications
      [notificationType]="'page'"
      [notification]="notification"
    ></app-notifications>
  </ng-container>
  <div class="d-flex" *ngIf="!notifications?.length">
    <p style="text-align: center; width: 100%; padding: 80px 0px">
      No Messages Found!
    </p>
  </div>
</div>
